export default {
    data() {
        return {
            url: '',
            axiosCancelSource: null,
            set: { name: '', products: [] },
            products: [],
        }
    },

    mounted() {
        this.loadProducts()

        if (this.$route.params.id) {
            this.url = 'admin/product_sets/' + this.$route.params.id
            this.getProductSet()
        } else {
            this.url = 'admin/product_sets'
            this.$nextTick(() => {
                if (this.$refs.setForm) {
                    this.$refs.setForm.setDisabled(false)
                }
            })
        }
    },

    beforeDestroy() {
        if (this.axiosCancelSource) {
            this.axiosCancelSource.cancel('component destroyed')
        }
    },

    methods: {
        async loadProducts() {
            try {
                const res = await this.$axios.get('admin/products?all=1')
                this.products = (res.data.data.products || []).map((p, i) => ({
                    id: p.id,
                    title: p.title,
                    label: `شناسه : ${p.id} | ${p.title}`,
                    index: i
                }))
            } catch (error) {
                this.$root.notify(error)
            }
        },

        async getProductSet() {
            try {
                this.axiosCancelSource = this.$axios.CancelToken.source()
                const response = await this.$axios.get(this.url, {
                    cancelToken: this.axiosCancelSource.token
                })

                const ps = response.data.data.product_set || { name: '', products: [] }

                this.set = {
                    name: ps.name || '',
                    products: (ps.products || []).map((p, i) => ({
                        id: p.id,
                        title: p.title,
                        index: i
                    }))
                }

                if (this.$refs.setForm) this.$refs.setForm.setDisabled(false)

            } catch (error) {
                if (this.$axios.isCancel && this.$axios.isCancel(error)) return
                this.$root.notify(error)
            }
        }
    }
}